// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-template-management[data-v-3b69c3be] {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
